/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdStandings200Ok
 */
export interface GetCorporationsCorporationIdStandings200Ok {
    /**
     * from_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdStandings200Ok
     */
    fromId: number;
    /**
     * from_type string
     * @type {string}
     * @memberof GetCorporationsCorporationIdStandings200Ok
     */
    fromType: GetCorporationsCorporationIdStandings200OkFromTypeEnum;
    /**
     * standing number
     * @type {number}
     * @memberof GetCorporationsCorporationIdStandings200Ok
     */
    standing: number;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdStandings200OkFromTypeEnum = {
    Agent: 'agent',
    NpcCorp: 'npc_corp',
    Faction: 'faction'
} as const;
export type GetCorporationsCorporationIdStandings200OkFromTypeEnum = typeof GetCorporationsCorporationIdStandings200OkFromTypeEnum[keyof typeof GetCorporationsCorporationIdStandings200OkFromTypeEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdStandings200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdStandings200Ok(value: object): value is GetCorporationsCorporationIdStandings200Ok {
    if (!('fromId' in value) || value['fromId'] === undefined) return false;
    if (!('fromType' in value) || value['fromType'] === undefined) return false;
    if (!('standing' in value) || value['standing'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdStandings200OkFromJSON(json: any): GetCorporationsCorporationIdStandings200Ok {
    return GetCorporationsCorporationIdStandings200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStandings200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdStandings200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'fromId': json['from_id'],
        'fromType': json['from_type'],
        'standing': json['standing'],
    };
}

export function GetCorporationsCorporationIdStandings200OkToJSON(json: any): GetCorporationsCorporationIdStandings200Ok {
    return GetCorporationsCorporationIdStandings200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStandings200OkToJSONTyped(value?: GetCorporationsCorporationIdStandings200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from_id': value['fromId'],
        'from_type': value['fromType'],
        'standing': value['standing'],
    };
}

